export default function(host, domRoot) {

    if(host === "www.editionsmr.fr") {

        if(document.querySelector("#gustave-cart")) document.querySelector("#gustave-cart").style.borderRadius = 0;

        if(domRoot.querySelectorAll("#widget, #widget button, #widget input, #widget select")) {
            let elements = Array.from(domRoot.querySelectorAll("#widget, #widget button, #widget input, #widget select"));
            for(let i = 0; i < elements.length; i++) {
                elements[i].style.borderRadius = 0;
            }
        }

        if(domRoot.querySelectorAll(".restant-txt, .txt-subtitle, #widget input, #widget button, #div-msgCabEmpty, .txt-slide-1, #btnPlanifier, .input-sub-msg, .div-stripe, .loading-slide, .txt-trans-secur, .cab-txts, .cab-infos, .ccm-txt, .ant-steps-item-title, .ant-steps-item-icon, .txt-info-service, .txt-slide-paiement, .txt-valid-cgv, .btns_quantity") && window.innerWidth > 479) {
            let elements = Array.from(domRoot.querySelectorAll(".restant-txt, .txt-subtitle, #widget input, #widget button, #div-msgCabEmpty, .txt-slide-1, #btnPlanifier, .input-sub-msg, .div-stripe, .loading-slide, .txt-trans-secur, .cab-txts, .cab-infos, .ccm-txt, .ant-steps-item-title, .ant-steps-item-icon, .txt-info-service, .txt-slide-paiement, .txt-valid-cgv, .btns_quantity"));
            for(let i = 0; i < elements.length; i++) {
                elements[i].style.fontSize = "12px";
            }
        }

        var spanBtnTry = document.querySelector("#txt1");
        if(window.innerWidth < 1024) {
            if(spanBtnTry && spanBtnTry.innerText.indexOf("> ") !== -1) {
                spanBtnTry.innerText = spanBtnTry.innerText.replace("> ", "");
            }
        } else {
            if(spanBtnTry && spanBtnTry.innerText.indexOf("> ") === -1) {
                spanBtnTry.innerText = "> " + spanBtnTry.innerText;
            }
        }

        if(document.querySelector("#gustave-bann") && document.querySelector("#gustave-bann").style.display === "flex") {
            document.querySelector("#gustave-bann").style.background = "#7C98B0";
        }

        if(domRoot.querySelector("#overlay")) {
            domRoot.querySelector("#overlay").style.backgroundColor = "rgba(197, 197, 197, 0.25)";
        }

        if(domRoot.querySelector("#widget")) {
            domRoot.querySelector("#widget").style.fontFamily = "Gotham Book";
            domRoot.querySelector("#widget").style.color = "#3b3a3a";
        }


        if(domRoot.querySelectorAll("#widget .strongFont")) {
            let elements = Array.from(domRoot.querySelectorAll("#widget .strongFont"));
            for(let i = 0; i < elements.length; i++) {
                elements[i].style.fontWeight = "normal";
                elements[i].style.fontFamily = "GothamMedium";
            }
        }

        if(domRoot.querySelector(".widget-title .strongFont")) {
            domRoot.querySelector(".widget-title .strongFont").style.textDecoration = "none";
        }

        if(domRoot.querySelectorAll("#widget input, #widget select")) {
            let elements = Array.from(domRoot.querySelectorAll("#widget input, #widget select"));
            for(let i = 0; i < elements.length; i++) {
                elements[i].style.boxShadow = "none";
                elements[i].style.border = "none";
                elements[i].style.borderBottom = "1px solid #3b3a3a";
                elements[i].style.paddingLeft = "0";
                elements[i].style.paddingRight = "0";
                elements[i].style.fontFamily = "Gotham Book";
            }
        }

        if(domRoot.querySelectorAll(".cercleNum")) {
            let elements = Array.from(domRoot.querySelectorAll(".cercleNum"));
            for(let i = 0; i < elements.length; i++) {
                elements[i].style.fontFamily = "GothamMedium";
                elements[i].style.border = "none";
                elements[i].style.fontWeight = "normal";
                elements[i].style.alignItems = "flex-start";
                elements[i].style.color = "#3b3a3a";
                if(elements[i].innerText.indexOf(".") === -1) elements[i].innerText += ".";
            }
        }

        if(domRoot.querySelector("#inputPromo")) {
            domRoot.querySelector("#inputPromo").classList.add("no-right");
            domRoot.querySelector("#inputPromo").style.height = "40px";
            domRoot.querySelector("#inputPromo").style.paddingRight = "32px";
            domRoot.querySelector("#inputPromo").style.color = "#3B3A3A";
        }
        if(domRoot.querySelector("#checkPromo")) {
            domRoot.querySelector("#checkPromo").style.height = "38px";
            domRoot.querySelector("#checkPromo").style.right = "0";
            if(domRoot.querySelector("#checkPromo").disabled) domRoot.querySelector("#checkPromo").style.background = "rgba(0,0,0,.45)";
            else domRoot.querySelector("#checkPromo").style.background = "#3B3A3A";
        }

        if(domRoot.querySelectorAll(".cab-txts")) {
            let elements = Array.from(domRoot.querySelectorAll(".cab-txts"));
            for(let i = 0; i < elements.length; i++) {
                elements[i].style.top = "10px";
            }
        }
        if(domRoot.querySelectorAll(".cab-size")) {
            let elements = Array.from(domRoot.querySelectorAll(".cab-size"));
            for(let i = 0; i < elements.length; i++) {
                elements[i].style.position = "relative";
                elements[i].style.top = "-5px";
            }
        }
        if(domRoot.querySelectorAll(".cab-price")) {
            let elements = Array.from(domRoot.querySelectorAll(".cab-price"));
            for(let i = 0; i < elements.length; i++) {
                elements[i].style.marginTop = "0";
            }
        }

        if(domRoot.querySelector(".cab-btns")) domRoot.querySelector(".cab-btns").style.alignItems = "flex-end";



        if(domRoot.querySelector(".slide1")) domRoot.querySelector(".slide1").style.justifyContent = "center";

        if(domRoot.querySelectorAll(".slide1 .txts-slide")) {
            let elements = Array.from(domRoot.querySelectorAll(".slide1 .txts-slide"));
            for(let i = 0; i < elements.length; i++) {
                elements[i].style.alignItems = "flex-start";
                elements[i].style.height = "50px";
            }
        }

        if(domRoot.querySelectorAll(".txt-slide-1")) {
            let elements = Array.from(domRoot.querySelectorAll(".txt-slide-1"));
            for(let i = 0; i < elements.length; i++) {
                elements[i].style.fontWeight = "normal";
                elements[i].style.paddingLeft = "0px";
                elements[i].style.position = "relative";
                elements[i].style.top = "0";
                elements[i].style.color = "#3b3a3a";
            }
        }

        if(domRoot.querySelectorAll(".txts-lastSlide .txts-slide")) {
            let elements = Array.from(domRoot.querySelectorAll(".txts-lastSlide .txts-slide"));
            for(let i = 0; i < elements.length; i++) {
                elements[i].style.alignItems = "flex-start";
                elements[i].style.height = "auto";
            }
        }

        if(domRoot.querySelectorAll(".txt-slide-paiement, .accentPhrase, .stepsNum, #nextStepsTitle")) {
            let elements = Array.from(domRoot.querySelectorAll(".txt-slide-paiement, .accentPhrase, .stepsNum, #nextStepsTitle"));
            for(let i = 0; i < elements.length; i++) {
                elements[i].style.fontFamily = "GothamMedium";
                elements[i].style.fontWeight = "normal";
            }
        }

        if(domRoot.querySelector(".servDispoVilles")) {
            domRoot.querySelector(".servDispoVilles").style.textDecoration = "none";
            domRoot.querySelector(".servDispoVilles").style.textAlign = "left";
            domRoot.querySelector(".servDispoVilles").style.fontWeight = "normal";
            domRoot.querySelector(".servDispoVilles").style.opacity = "0.8";

            if(domRoot.querySelector(".servDispoVilles").innerText.indexOf("> ") === -1) domRoot.querySelector(".servDispoVilles").innerText = "> " + domRoot.querySelector(".servDispoVilles").innerText;
        }

        if(domRoot.querySelectorAll(".divJourOn, .divJourOff")) {
            let elements = Array.from(domRoot.querySelectorAll(".divJourOn, .divJourOff"));
            for(let i = 0; i < elements.length; i++) {
                elements[i].style.color = "rgba(0,0,0,.45)";
                elements[i].style.fontWeight = "normal";
                elements[i].style.fontFamily = "Gotham Book";
                if(elements[i].classList.contains("divJourOn")) elements[i].style.textDecoration = "none";
                else if(elements[i].classList.contains("divJourOff")) elements[i].style.textDecoration = "line-through";
            }
        }

        if(domRoot.querySelector(".divJourOn.select")) {
            domRoot.querySelector(".divJourOn.select").style.color = "#3b3a3a";
            domRoot.querySelector(".divJourOn.select").style.borderColor = "transparent";
            domRoot.querySelector(".divJourOn.select").style.textDecoration = "underline";
            domRoot.querySelector(".divJourOn.select").style.fontFamily = "GothamMedium";
        }

        if(domRoot.querySelectorAll(".liv-titles")) {
            let elements = Array.from(domRoot.querySelectorAll(".liv-titles"));
            for(let i = 0; i < elements.length; i++) {
                elements[i].style.textDecoration = "none";
                elements[i].style.fontFamily = "GothamMedium";
                if(window.innerWidth <= 479) {
                    elements[i].style.display = "flex";
                    elements[i].style.justifyContent = "center";
                    elements[i].style.alignItems = "center";
                    elements[i].style.height = "28px";
                }
            }
        }

        if(domRoot.querySelectorAll("#widget input")) {
            let elements = Array.from(domRoot.querySelectorAll("#widget input"));
            for(let i = 0; i < elements.length; i++) {
                elements[i].style.color = "#3b3a3a";
                elements[i].style.fontWeight = "normal";
                elements[i].style.borderColor = "rgba(0,0,0,.45)";
            }
        }

        if(domRoot.querySelectorAll("#widget .cab-title, #widget #cabPayInf")) {
            let elements = Array.from(domRoot.querySelectorAll("#widget .cab-title, #widget #cabPayInf"));
            for(let i = 0; i < elements.length; i++) {
                elements[i].style.fontFamily = "GothamMedium";
            }
        }

        if(domRoot.querySelector("#selectH")) {
            domRoot.querySelector("#selectH").style.color = "#3b3a3a";
            domRoot.querySelector("#selectH").style.fontWeight = "normal";
            domRoot.querySelector("#selectH").style.borderColor = "rgba(0,0,0,.45)";
        }

        if(domRoot.querySelectorAll(".order-step")) {
            let elements = Array.from(domRoot.querySelectorAll(".order-step"));
            for(let i = 0; i < elements.length; i++) {
                elements[i].style.display = "flex";
            }
        }

        if(domRoot.querySelectorAll(".ant-steps-item-icon")) {
            let elements = Array.from(domRoot.querySelectorAll(".ant-steps-item-icon"));
            for(let i = 0; i < elements.length; i++) {
                elements[i].style.background = "transparent";
                elements[i].style.border = "none";
                elements[i].style.marginRight = "0";
                elements[i].style.display = "flex";
                elements[i].style.flexFlow = "row nowrap";
                elements[i].style.width = "auto";
                elements[i].style.justifyContent = "flex-start";
                elements[i].style.height = "14px";
                elements[i].style.lineHeight = "14px";
            }
        }

        if(domRoot.querySelectorAll(".ant-steps-item-content")) {
            let elements = Array.from(domRoot.querySelectorAll(".ant-steps-item-content"));
            for(let i = 0; i < elements.length; i++) {
                elements[i].style.display = "flex";
                elements[i].style.flexFlow = "row nowrap";
                elements[i].style.width = "auto";
                elements[i].style.justifyContent = "flex-start";
                elements[i].style.marginLeft = "5px";
            }
        }

        if(domRoot.querySelectorAll(".ant-steps-item-title")) {
            let elements = Array.from(domRoot.querySelectorAll(".ant-steps-item-title"));
            for(let i = 0; i < elements.length; i++) {
                elements[i].classList.add("hide");
            }
        }

        if(domRoot.querySelectorAll(".checkStyle")) {
            let elements = Array.from(domRoot.querySelectorAll(".checkStyle"));
            for(let i = 0; i < elements.length; i++) {
                elements[i].style.color = "#3b3a3a";
            }
        }

        if(domRoot.querySelectorAll(".ant-steps-item-process > .ant-steps-item-icon > .ant-steps-icon, .ant-steps-item-finish > .ant-steps-item-icon > .ant-steps-icon")) {
            let elements = Array.from(domRoot.querySelectorAll(".ant-steps-item-process > .ant-steps-item-icon > .ant-steps-icon, .ant-steps-item-finish > .ant-steps-item-icon > .ant-steps-icon"));
            for(let i = 0; i < elements.length; i++) {
                elements[i].style.color = "#3b3a3a";
                elements[i].style.fontWeight = "normal";
            }
        }

        if(domRoot.querySelector(".ant-steps-item-wait > .ant-steps-item-icon > .ant-steps-icon")) {
            let elements = Array.from(domRoot.querySelectorAll(".ant-steps-item-wait > .ant-steps-item-icon > .ant-steps-icon"));
            for(let i = 0; i < elements.length; i++) {
                elements[i].style.color = "rgba(0,0,0,.45)";
            }
        }

        if(domRoot.querySelectorAll("#widget .div-steps .ant-steps-item-icon > .ant-steps-icon")) {
            let elements = Array.from(domRoot.querySelectorAll("#widget .div-steps .ant-steps-item-icon > .ant-steps-icon"));
            for(let i = 0; i < elements.length; i++) {
                elements[i].style.lineHeight = "24px";
                elements[i].style.top = "0";
            }
        }

        if(domRoot.querySelector(".ant-steps-item-process > .ant-steps-item-icon > .ant-steps-icon, .ant-steps-item-wait > .ant-steps-item-icon > .ant-steps-icon")) {
            let elements = Array.from(domRoot.querySelectorAll(".ant-steps-item-process > .ant-steps-item-icon > .ant-steps-icon, .ant-steps-item-wait > .ant-steps-item-icon > .ant-steps-icon"));
            for(let i = 0; i < elements.length; i++) {
                if(elements[i].innerText.indexOf(".") === -1) elements[i].innerText += ".";
            }
        }


        if(domRoot.querySelectorAll(".ant-steps-item-finish > .ant-steps-item-icon > .ant-steps-icon")) {
            let elements = Array.from(domRoot.querySelectorAll(".ant-steps-item-finish > .ant-steps-item-icon > .ant-steps-icon"));
            for(let i = 0; i < elements.length; i++) {
                if(elements[i].innerText.indexOf(".") !== -1) elements[i].innerText.replace(".", "");
            }
        }

        if(domRoot.querySelector(".ant-steps-item-content > .ant-steps-item-title, .ant-steps-item-icon > .ant-steps-icon")) {
            let elements = Array.from(domRoot.querySelectorAll(".ant-steps-item-content > .ant-steps-item-title, .ant-steps-item-icon > .ant-steps-icon"));
            for(let i = 0; i < elements.length; i++) {
                elements[i].style.fontFamily = "Gotham Book";
            }
        }

        if(domRoot.querySelector(".ant-steps-item-process > .ant-steps-item-content > .ant-steps-item-title, .ant-steps-item-process > .ant-steps-item-icon > .ant-steps-icon, .ant-steps-item-finish > .ant-steps-item-content > .ant-steps-item-title, .ant-steps-item-finish > .ant-steps-item-icon > .ant-steps-icon, #plan-ok-txt")) {
            let elements = Array.from(domRoot.querySelectorAll(".ant-steps-item-process > .ant-steps-item-content > .ant-steps-item-title, .ant-steps-item-process > .ant-steps-item-icon > .ant-steps-icon, .ant-steps-item-finish > .ant-steps-item-content > .ant-steps-item-title, .ant-steps-item-finish > .ant-steps-item-icon > .ant-steps-icon, #plan-ok-txt"));
            for(let i = 0; i < elements.length; i++) {
                elements[i].style.color = "#3b3a3a";
                elements[i].style.fontFamily = "GothamMedium";
            }
        }

        if(domRoot.querySelectorAll(".cab-txts, .cab-infos, .ccm-txt, .ant-input, .txt-info-service, .txt-slide-paiement, .txt-valid-cgv, .txt-trans-secur, #div-msgCabEmpty")) {
            let elements = Array.from(domRoot.querySelectorAll(".cab-txts, .cab-infos, .ccm-txt, .ant-input, .txt-info-service, .txt-slide-paiement, .txt-valid-cgv, .txt-trans-secur, #div-msgCabEmpty"));
            for(let i = 0; i < elements.length; i++) {
                elements[i].style.color = "#3b3a3a";
            }
        }

        if(domRoot.querySelector(".cab-infos")) {
            domRoot.querySelector(".cab-infos").style.bottom = "11px";
        }

        if(domRoot.querySelector(".ccm-txt")) {
            domRoot.querySelector(".ccm-txt").style.fontWeight = "normal";
            domRoot.querySelector(".ccm-txt").style.textDecoration = "none";
        }

        if(domRoot.querySelector("#btnAide")) domRoot.querySelector("#btnAide").style.display = "none";

        if(domRoot.querySelector(".cintre-anime")) domRoot.querySelector(".cintre-anime").style.display = "none";

        if(domRoot.querySelector("#btns-lang")) domRoot.querySelector("#btns-lang").style.display = "none";

        if(domRoot.querySelector("#btn-precInf")) {
            domRoot.querySelector("#btn-precInf").classList.remove("widget-btns");
            domRoot.querySelector("#btn-precInf").style.display = "none";
        }

        if(domRoot.querySelector("#btn-prec-paiement")) {
            domRoot.querySelector("#btn-prec-paiement").classList.remove("widget-btns-sc");
            domRoot.querySelector("#btn-prec-paiement").style.display = "none";
        }

        if(domRoot.querySelectorAll("#btn-arrow, #btn-close, #btn-ccm")) {
            let elements = Array.from(domRoot.querySelectorAll("#btn-arrow, #btn-close, #btn-ccm"));
            for(let i = 0; i < elements.length; i++) {
                elements[i].style.border = "none";
                elements[i].style.background = "transparent";
            }
        }

        if(domRoot.querySelectorAll(".widget-btns")) {
            let elements = Array.from(domRoot.querySelectorAll(".widget-btns"));
            for(let i = 0; i < elements.length; i++) {
                elements[i].style.height = "40px";
                elements[i].style.background = "#3b3a3a";
                elements[i].style.borderColor = "#3b3a3a";
                elements[i].style.color = "white";
                elements[i].style.display = "flex";
                elements[i].style.justifyContent = "center";
                elements[i].style.alignItems = "center";
                elements[i].style.padding = "0";
                if(window.innerWidth <= 320) {
                    elements[i].style.width = "140px";
                } else if(window.innerWidth <= 479) {
                    elements[i].style.width = "160px";
                } else {
                    elements[i].style.width = "200px";
                }
                if(elements[i].disabled) elements[i].style.color = "rgba(255, 255, 255, .5)";
                else elements[i].style.color = "rgba(255, 255, 255, 1)";
            }
        }

        if(domRoot.querySelectorAll(".widget-btns-sc")) {
            let elements = Array.from(domRoot.querySelectorAll(".widget-btns-sc"));
            for(let i = 0; i < elements.length; i++) {
                elements[i].style.height = "40px";
                elements[i].style.background = "#3b3a3a";
                elements[i].style.color = "white";
                elements[i].style.borderColor = "#3b3a3a";
                elements[i].style.display = "flex";
                elements[i].style.justifyContent = "center";
                elements[i].style.alignItems = "center";
                elements[i].style.padding = "0";
                if(window.innerWidth <= 320) {
                    elements[i].style.width = "140px";
                } else if(window.innerWidth <= 479) {
                    elements[i].style.width = "160px";
                } else {
                    elements[i].style.width = "200px";
                }
                if(elements[i].disabled) elements[i].style.color = "rgba(255, 255, 255, .5)";
                else elements[i].style.color = "rgba(255, 255, 255, 1)";
            }
        }

        if(domRoot.querySelectorAll(".widget-btns-inv")) {
            let elements = Array.from(domRoot.querySelectorAll(".widget-btns-inv"));
            for(let i = 0; i < elements.length; i++) {
                elements[i].style.height = "40px";
                elements[i].style.background = "white";
                elements[i].style.color = "#3b3a3a";
                elements[i].style.borderColor = "#3b3a3a";
                elements[i].style.display = "flex";
                elements[i].style.justifyContent = "center";
                elements[i].style.alignItems = "center";
                elements[i].style.padding = "0";
                if(window.innerWidth <= 320) {
                    elements[i].style.width = "140px";
                } else if(window.innerWidth <= 479) {
                    elements[i].style.width = "160px";
                } else {
                    elements[i].style.width = "200px";
                }
            }
        }

        if(domRoot.querySelector(".faq")) {
            domRoot.querySelector(".faq").style.bottom = "-80px";
        }

        if(window.innerWidth <= 479) {
            if(domRoot.querySelectorAll(".ant-steps-item")) {
                let elements = Array.from(domRoot.querySelectorAll(".ant-steps-item"));
                for(let i = 0; i < elements.length; i++) {
                    elements[i].style.flexDirection = "row";
                    elements[i].style.alignItems = "flex-start";
                }
            }
        }
    }
}